import { useContext, useMemo } from 'react'

import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { GlobalContext } from '../../../../Providers/GlobalProvider'
import { isNonEmptyArray } from '../../../../utils'
import EntitiesSelector from '../EntitiesSelector'

const LocaleLanguagesSelector = ({ languages, className = '', disabled, multiple = 'default', style = {}, values, onChange }) => {
  const t = useSelector(selectTranslate)
  const gc = useContext(GlobalContext)

  const entities = useMemo(() => isNonEmptyArray(languages) ? languages : gc.languages, [languages, gc?.languages])

  const languagesOptions = useMemo(() => entities.flatMap(language => language.languageLocales.map(locale => ({
    label: locale.nameInNativeLanguage,
    value: locale.languageTag,
    tooltip: t('languages.' + locale.languageTag),
    entity: locale
  }))), [entities, t])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={languagesOptions}
      multiple={multiple}
      style={style}
      values={values}
      onChange={onChange}
    />
  )
}

export default LocaleLanguagesSelector
